import { render, staticRenderFns } from "./IntelligentFedding.vue?vue&type=template&id=63730b5a&scoped=true"
import script from "./IntelligentFedding.vue?vue&type=script&lang=js"
export * from "./IntelligentFedding.vue?vue&type=script&lang=js"
import style0 from "./IntelligentFedding.vue?vue&type=style&index=0&id=63730b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63730b5a",
  null
  
)

export default component.exports